module.exports = __webpack_public_path__ + "media/images/Cup-and-Candle-1920px-3-e2c39d526256815f567121b8cbc539a2.png";